var React = require('react');

function IcNavMainStage (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M15.372 7.66526l8.628.7179L17.46 13.86 19.416 22 12 17.6811 4.584 22l1.968-8.14L0 8.38316l8.628-.70632L12 0l3.372 7.66526zM7.86391 17.7866l4.13599-2.497 4.147 2.508-1.1-4.708 3.652-3.16804-4.818-.418-1.881-4.444-1.87 4.433-4.81799.418 3.652 3.16804-1.1 4.708z","fill":"currentColor"}));
}

IcNavMainStage.defaultProps = {"fill":"none","viewBox":"0 0 24 22"};

module.exports = IcNavMainStage;

IcNavMainStage.default = IcNavMainStage;
